import React, { useState } from "react";
import DishCardStyles from "./styles";
import {
  BsThreeDotsVertical,
  BsChevronDown,
  BsChevronUp,
} from "react-icons/bs";

const dishCover = (
  <svg
    width="22"
    height="17"
    viewBox="0 0 22 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.42633 15.0191H19.3003L19.3006 14.8421L2.42633 15.0191ZM2.42633 15.0191V14.8421C2.42633 13.4907 2.65006 12.1813 3.09153 10.9502L3.09154 10.9502C3.5178 9.7603 4.12718 8.69228 4.90343 7.77611L4.90346 7.77608C5.67969 6.85923 6.58303 6.14129 7.58529 5.63972L2.42633 15.0191ZM16.8235 7.77611L16.8235 7.77608C16.0473 6.85923 15.1439 6.14129 14.1417 5.63972L16.8235 7.77611ZM16.8235 7.77611C17.5998 8.69228 18.2091 9.76029 18.6354 10.9502M16.8235 7.77611L18.6354 10.9502M18.6354 10.9502C19.0761 12.1811 19.3006 13.4906 19.3006 14.8419L18.6354 10.9502ZM18.6354 10.9502L18.7296 10.9165L18.6354 10.9502C18.6354 10.9502 18.6354 10.9502 18.6354 10.9502ZM21.4638 15.5598C21.4636 15.2905 21.2838 15.0426 21.0268 15.0209L21.0246 15.0191H20.9897H20.2464V14.8421C20.2464 9.47141 17.0016 4.87915 12.5048 3.94378L12.4844 4.04168L12.5048 3.94378L12.3213 3.90563L12.4045 3.6894C12.4045 3.68933 12.4046 3.68926 12.4046 3.68919C12.504 3.4328 12.5535 3.16019 12.5535 2.87883C12.5535 1.80281 11.8111 0.9 10.8636 0.9C9.91609 0.9 9.17366 1.80281 9.17366 2.87883C9.17366 3.16008 9.22324 3.43296 9.32266 3.6894L9.40584 3.90563L9.2224 3.94378L9.24276 4.04168L9.22239 3.94378C4.72576 4.87906 1.48075 9.47141 1.48075 14.8421V15.0192L0.73745 15.0193C0.737443 15.0193 0.737436 15.0193 0.737429 15.0193C0.46097 15.0193 0.26377 15.2778 0.26377 15.5598C0.26377 15.8416 0.46075 16.1012 0.73745 16.1012H20.9901C21.2668 16.1012 21.4638 15.8418 21.4638 15.5598V15.5598ZM10.8632 1.98345C11.2578 1.98345 11.6065 2.36842 11.6065 2.87885C11.6065 3.38768 11.2576 3.77354 10.8632 3.77354C10.4686 3.77354 10.1199 3.38786 10.1199 2.87885C10.1199 2.36846 10.4687 1.98345 10.8632 1.98345ZM7.58535 5.63969C9.66172 4.60236 12.0653 4.60236 14.1416 5.63969H7.58535Z"
      fill="#8C8994"
      stroke="#8C8994"
      strokeWidth="0.2"
    />
  </svg>
);

const location = (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.15842 6.5546L8.15842 6.55459C7.8936 6.27839 7.63676 5.97952 7.40569 5.68175C7.37999 5.59218 7.31977 5.51641 7.23995 5.46373C7.10456 5.27787 6.98323 5.09556 6.88251 4.92265C6.91551 4.76028 6.82658 4.60621 6.6793 4.52422C6.60534 4.34691 6.56745 4.19547 6.56745 4.07617C6.56745 2.77244 7.85763 1.68944 9.50137 1.68944C11.145 1.68944 12.4324 2.77231 12.4324 4.07615C12.4324 4.19769 12.3927 4.35275 12.3158 4.53448C12.18 4.61569 12.0977 4.7597 12.1227 4.91313C12.0194 5.09147 11.8939 5.28008 11.7535 5.47236C11.6814 5.52262 11.6263 5.59226 11.6001 5.67414C11.3675 5.97436 11.1078 6.27594 10.8407 6.5546C10.2049 7.21789 9.73219 7.61557 9.5013 7.80785C9.27012 7.6158 8.79455 7.21818 8.15842 6.5546ZM7.4489 7.05635L7.52109 6.98715L7.4489 7.05635C8.07866 7.71335 8.59527 8.16545 8.88387 8.41089V10.6401H5.84633C5.90643 9.07637 6.31699 7.61297 6.97087 6.53709C7.12786 6.71437 7.28834 6.88885 7.4489 7.05635ZM9.7537 8.59068L9.78141 8.62463H9.7814L9.7537 8.59068ZM9.80313 8.67885C9.80761 8.67552 9.81199 8.67212 9.8163 8.66867L9.81692 8.66816L9.80313 8.65127V8.65123L9.81694 8.66814L9.81698 8.66811L9.81712 8.668L9.81763 8.66758L9.81958 8.66598L9.82714 8.65977L9.8563 8.63564C9.88178 8.61446 9.91904 8.58328 9.96642 8.54307C10.0612 8.46266 10.1964 8.34614 10.3587 8.20138C10.6832 7.91196 11.1164 7.50917 11.5506 7.05616L11.5506 7.05615C11.7111 6.88869 11.8722 6.71432 12.0294 6.53699C12.684 7.61271 13.0964 9.07625 13.1567 10.6401H9.80313V8.67885ZM14.0747 11.4295H17.1645C16.9695 13.9949 14.8889 16.1522 12.0174 16.9643C12.3162 16.6669 12.5872 16.322 12.8248 15.9381L12.8248 15.9381C13.5609 14.7483 14.0141 13.1703 14.0747 11.4295ZM9.50137 0.9C7.39762 0.9 5.6479 2.30806 5.6479 4.07615C5.6479 4.2755 5.68957 4.47735 5.75584 4.67723C2.81288 5.84693 0.9 8.30368 0.9 11.0338C0.9 14.9506 4.77623 18.1 9.50144 18.1C14.2267 18.1 18.1 14.9507 18.1 11.0338C18.1 8.30331 16.1872 5.84602 13.2437 4.67653C13.3099 4.47685 13.3517 4.27523 13.3517 4.07598C13.3517 2.30798 11.6052 0.9 9.50137 0.9ZM9.50137 2.49503C8.63521 2.49503 7.88805 3.08128 7.88805 3.83495C7.88805 4.58884 8.63548 5.17251 9.50137 5.17251C10.3676 5.17251 11.1112 4.58861 11.1112 3.83495C11.1112 3.08151 10.3679 2.49503 9.50137 2.49503ZM9.50137 3.28447C9.90705 3.28447 10.1921 3.54523 10.1921 3.83495C10.1921 4.12425 9.90754 4.38307 9.50137 4.38307C9.09469 4.38307 8.80781 4.12384 8.80781 3.83495C8.80781 3.54564 9.09521 3.28447 9.50137 3.28447ZM1.83921 10.6402C2.01077 8.40405 3.63251 6.40453 6.10608 5.40811C6.19001 5.5453 6.28228 5.68211 6.38187 5.81793C5.49501 7.07532 4.99002 8.80342 4.92606 10.6402H1.83921ZM12.8938 5.40811C15.3672 6.40449 16.9885 8.40411 17.1602 10.6404H14.0734C14.0096 8.80343 13.5047 7.07573 12.6176 5.81812C12.7172 5.68228 12.8097 5.54546 12.8938 5.40811ZM6.17552 15.9383C6.4128 16.3219 6.68341 16.6666 6.98192 16.9638C4.1112 16.151 2.03 13.9942 1.83507 11.4295H4.92487C4.98562 13.1702 5.43936 14.7484 6.17552 15.9383ZM6.98749 15.5652C6.33781 14.5152 5.90638 13.0567 5.84496 11.4295H8.88383V17.2089C8.19521 16.9979 7.52927 16.4407 6.98749 15.5652ZM9.80293 11.4295H13.1579C13.0964 13.0568 12.6644 14.5153 12.0147 15.5653C11.3896 16.5755 10.6021 17.1677 9.80293 17.2871V11.4295Z"
      fill="#8C8994"
      stroke="#8C8994"
      strokeWidth="0.2"
    />
  </svg>
);

const like = (
  <svg
    width="19"
    height="17"
    viewBox="0 0 19 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.6465 0.388042C12.8773 0.395484 12.1204 0.582997 11.4367 0.935557C10.7529 1.28812 10.1612 1.79592 9.70903 2.41829C9.25683 1.79592 8.66515 1.28812 7.98139 0.935557C7.29763 0.582997 6.5408 0.395484 5.77153 0.388042C4.37786 0.443697 3.06292 1.04893 2.11424 2.07139C1.16556 3.09385 0.660336 4.45036 0.70903 5.84429C0.70903 9.25829 4.21453 12.913 7.15903 15.3783C7.87403 15.9795 8.77824 16.3091 9.71241 16.3091C10.6466 16.3091 11.5508 15.9795 12.2658 15.3783C15.2073 12.913 18.7158 9.25829 18.7158 5.84429C18.7644 4.44923 18.2583 3.09174 17.3082 2.06909C16.3581 1.04643 15.0414 0.441959 13.6465 0.388042ZM10.8168 13.654C10.5066 13.9152 10.1141 14.0584 9.70866 14.0584C9.30317 14.0584 8.91071 13.9152 8.60053 13.654C5.01553 10.648 2.95903 7.80179 2.95903 5.84429C2.91121 5.0472 3.17974 4.26343 3.70632 3.66313C4.23289 3.06283 4.97501 2.69448 5.77153 2.63804C6.56806 2.69448 7.31017 3.06283 7.83674 3.66313C8.36332 4.26343 8.63185 5.0472 8.58403 5.84429C8.58403 6.14266 8.70256 6.42881 8.91354 6.63979C9.12451 6.85077 9.41066 6.96929 9.70903 6.96929C10.0074 6.96929 10.2935 6.85077 10.5045 6.63979C10.7155 6.42881 10.834 6.14266 10.834 5.84429C10.7862 5.0472 11.0547 4.26343 11.5813 3.66313C12.1079 3.06283 12.85 2.69448 13.6465 2.63804C14.4431 2.69448 15.1852 3.06283 15.7117 3.66313C16.2383 4.26343 16.5069 5.0472 16.459 5.84429C16.459 7.80179 14.4025 10.648 10.8168 13.654Z"
      fill="#FF4C4C"
    />
  </svg>
);

const smile = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.375 5.25C6.88875 5.26703 7.37474 5.48723 7.72628 5.86225C8.07782 6.23728 8.26618 6.73647 8.25 7.25025C8.25 8.25 7.41075 8.25 6.375 8.25C5.33925 8.25 4.5 8.25 4.5 7.25025C4.48383 6.73647 4.67218 6.23728 5.02373 5.86225C5.37527 5.48723 5.86126 5.26703 6.375 5.25ZM9.75 7.25025C9.75 8.25 10.5893 8.25 11.625 8.25C12.6608 8.25 13.5 8.25 13.5 7.25025C13.5162 6.73647 13.3278 6.23728 12.9763 5.86225C12.6247 5.48723 12.1387 5.26703 11.625 5.25C11.1113 5.26703 10.6253 5.48723 10.2737 5.86225C9.92218 6.23728 9.73383 6.73647 9.75 7.25025ZM18 9C18 7.21996 17.4722 5.47991 16.4832 3.99986C15.4943 2.51982 14.0887 1.36627 12.4442 0.685081C10.7996 0.00389194 8.99002 -0.174338 7.24419 0.172929C5.49836 0.520196 3.89472 1.37736 2.63604 2.63604C1.37737 3.89471 0.520204 5.49835 0.172937 7.24418C-0.17433 8.99001 0.00389957 10.7996 0.685088 12.4441C1.36628 14.0887 2.51983 15.4943 3.99987 16.4832C5.47991 17.4722 7.21997 18 9 18C11.3862 17.9974 13.6738 17.0484 15.3611 15.3611C17.0484 13.6738 17.9974 11.3862 18 9ZM15.75 9C15.75 10.335 15.3541 11.6401 14.6124 12.7501C13.8707 13.8601 12.8165 14.7253 11.5831 15.2362C10.3497 15.7471 8.99252 15.8807 7.68314 15.6203C6.37377 15.3598 5.17104 14.717 4.22703 13.773C3.28303 12.829 2.64015 11.6262 2.3797 10.3169C2.11925 9.00748 2.25293 7.65028 2.76382 6.41688C3.27471 5.18348 4.13987 4.12928 5.2499 3.38758C6.35994 2.64588 7.66498 2.25 9 2.25C10.7895 2.25218 12.5052 2.96404 13.7706 4.22944C15.036 5.49483 15.7478 7.21046 15.75 9ZM13.1678 11.673C13.3742 11.462 13.4895 11.1784 13.4887 10.8832C13.488 10.5881 13.3712 10.305 13.1637 10.0951C12.9562 9.88525 12.6745 9.76532 12.3793 9.76123C12.0842 9.75713 11.7993 9.86919 11.586 10.0732C10.8795 10.7432 9.9692 11.1574 9 11.25C8.03256 11.1578 7.12368 10.7449 6.41775 10.077C6.20492 9.87266 5.92033 9.76011 5.62531 9.7636C5.33029 9.76709 5.04844 9.88634 4.84051 10.0957C4.63257 10.305 4.51518 10.5876 4.51364 10.8826C4.51209 11.1777 4.62652 11.4615 4.83225 11.673C5.96147 12.7561 7.4383 13.4035 9 13.5C10.5617 13.4035 12.0385 12.7561 13.1678 11.673Z"
      fill="#8C8994"
    />
  </svg>
);

const sad = (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.46585 5.22794C6.96698 5.22794 7.46811 5.42901 7.86902 5.83116C8.26992 6.23331 8.37014 6.73599 8.37014 7.23868C8.37014 8.24405 7.56834 8.24405 6.46585 8.24405C5.36337 8.24405 4.56157 8.24405 4.56157 7.23868C4.56157 6.73599 4.76202 6.23331 5.06269 5.83116C5.4636 5.52955 5.96473 5.32848 6.46585 5.22794ZM9.87353 7.33922C9.87353 8.34459 10.6753 8.34459 11.7778 8.34459C12.7801 8.34459 13.6821 8.34459 13.6821 7.33922C13.6821 6.83653 13.4817 6.33385 13.181 5.9317C12.7801 5.52955 12.3792 5.32848 11.7778 5.32848C11.2767 5.32848 10.7756 5.52955 10.3747 5.9317C9.97376 6.23331 9.7733 6.73599 9.87353 7.33922ZM18.092 9.04834C18.092 7.23868 17.5909 5.52955 16.5887 4.0215C15.5864 2.51344 14.1832 1.40754 12.5796 0.703778C10.8758 1.98702e-05 9.07172 -0.201054 7.26766 0.201094C5.4636 0.603241 3.96021 1.40754 2.65728 2.61398C1.45457 3.92096 0.552536 5.52955 0.251858 7.23868C-0.0488189 8.94781 0.0514068 10.858 0.752987 12.4666C1.45457 14.0752 2.55705 15.5832 4.06044 16.4881C5.56382 17.4934 7.26766 17.9961 9.07172 17.9961C11.4771 17.9961 13.7823 16.9908 15.4862 15.3822C17.19 13.7736 18.092 11.4612 18.092 9.04834ZM15.8871 9.04834C15.8871 10.3553 15.4862 11.6623 14.7846 12.8687C14.083 14.0752 12.9805 14.8795 11.7778 15.3822C10.5751 15.8849 9.17195 15.9854 7.86902 15.7843C6.56608 15.4827 5.36337 14.8795 4.36111 13.9747C3.45908 13.0698 2.7575 11.8634 2.55705 10.4559C2.15615 9.04834 2.3566 7.74136 2.85773 6.43438C3.35886 5.1274 4.26089 4.12203 5.36337 3.41828C6.46586 2.71452 7.76879 2.21183 9.07172 2.21183C10.8758 2.21183 12.5796 2.91559 13.8826 4.22257C15.0853 5.52955 15.7868 7.23868 15.8871 9.04834ZM4.86224 11.6623C4.66179 11.8634 4.56157 12.165 4.56157 12.4666C4.56157 12.7682 4.66179 13.0698 4.86224 13.2709C5.06269 13.472 5.36337 13.5725 5.66405 13.5725C5.96473 13.5725 6.2654 13.472 6.46585 13.2709C7.16744 12.5671 8.06947 12.165 9.07172 12.0645C10.074 12.165 10.976 12.5671 11.6776 13.2709C11.878 13.472 12.1787 13.5725 12.4794 13.5725C12.7801 13.5725 13.0808 13.472 13.2812 13.2709C13.4817 13.0698 13.5819 12.7682 13.5819 12.4666C13.5819 12.165 13.4817 11.8634 13.2812 11.6623C12.0785 10.5564 10.6753 9.95318 9.07172 9.85264C7.46811 9.95318 6.06495 10.5564 4.86224 11.6623Z"
      fill="#8C8994"
    />
  </svg>
);

function convert(value) {
  if (value >= 1000000) {
    value = value / 1000000 + "M";
  } else if (value >= 1000) {
    value = value / 1000 + "K";
  }
  return value;
}

const DishCard = ({
  dishImage,
  dishName,
  restaurant,
  cuisine,
  price,
  postedBy,
  likeCount,
  loveCount,
  regretCount,
}) => {
  const [seeMore, setSeeMore] = useState(false);

  const setSeeMoreHandle = () => {
    setSeeMore(!seeMore);
  };

  return (
    <DishCardStyles>
      <div className="dish-content">
        <div className="image">
          <img src={dishImage} alt="dish" />
        </div>
        <div className="content">
          <div className="dish-title">
            <h3 className="dish-name">{dishName}</h3>
            <BsThreeDotsVertical className="three-dots" />
          </div>
          <div className="price-restaurant">
            <p className="restaurant">
              In <span>{restaurant}</span>
            </p>
            <p className="price">{price ? `$${price}` : 'N/A'}</p>
          </div>
          <div className="location">
            <p className="entrees">
              {dishCover}
              <span>Entrees</span>
            </p>
            <p className="location">
              {location}
              <span>{cuisine}</span>
            </p>
          </div>
          <div className="other-details">
            <p className="posted-by">
              Posted by <span>{postedBy}</span>
            </p>
            <p className="see-more" onClick={setSeeMoreHandle}>
              <span>
                See More {!seeMore ? <BsChevronDown /> : <BsChevronUp />}
              </span>
            </p>
          </div>
        </div>
      </div>
      {seeMore && (
        <div className="info">
          <div className="allergy">
            <p>
              <span>Allergy Info:</span> gluten free, nuts, etc.
            </p>
            <p>
              <span>Content Info:</span> Vegan, Vegeterian, Chicken, etc.
            </p>
          </div>
          <div className="hashtag">
            <p>
              <span>Hashtag:</span> gluten free, nuts, etc.
            </p>
          </div>
        </div>
      )}
      <div className="reactions">
        <div>
          {like} {convert(loveCount)}
        </div>
        <div>
          {smile} {convert(likeCount)}
        </div>
        <div>
          {sad} {convert(regretCount)}
        </div>
      </div>
    </DishCardStyles>
  );
};

export default DishCard;
